// Copyright (c) StrangeBee 2023

import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import RouteBuilder from '@Services/RouteBuilder';
import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';

export const CustomEvent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();

    const { _id: caseId } = data || {};

    const { _id, details, context, action } = base;

    const rootPath = RouteBuilder.compute('cases.timeline', { caseId });

    const libTitle: Record<string, string> = {
        create: local('stream.card.customevent.create'),
        update: local('stream.card.customevent.update'),
        delete: local('stream.card.customevent.delete'),
    };

    return (
        <StreamCard
            icon={<ICONS.TimelineEventIcon />}
            title={rootPath ? libTitle[action] : libTitle.Delete}
            path={rootPath}
            base={base}
            parent={context}
        >
            {Object.entries(details).map(([key, value]) => (
                <PropRender key={key + _id} prop={key} value={value} type="customevent" />
            ))}
        </StreamCard>
    );
};
